export const LIVE_FEED_PAGINATION_ITEMS_PER_PAGE = 50;
export const LIVE_FEED_PAGINATION_START_PAGE_INDEX = 1;
